/* Maison Dorian, PDP v2 lot B : packs 1 / 2 / 3 et achat direct au checkout.
   API : window.mdBuy = { getSelection(), checkout(opts?) }.
   Evenement : document 'md:selection-change' (detail = getSelection()).
   Evenement : document 'md:checkout-state' (detail = {busy:boolean}).
   Le DOM PDP vit dans des shadow roots : toutes les recherches les traversent. */
(function () {
  'use strict';
  if (window.mdBuy) return;

  var DATA = null, S = [], byId = {}, byH = {}, cur = null;
  var state = { pack: 2, slots: { 2: [], 3: [] } };
  var busy = false, busyP = null, busyTimer = 0, ready = false;
  var BEST = ['ventura', 'visionaire'];
  var SYM = { EUR: '€', USD: '$', GBP: '£' };

  function roots(r, a) { a.push(r); r.querySelectorAll('*').forEach(function (e) { if (e.shadowRoot) roots(e.shadowRoot, a); }); return a; }
  function all(sel) { var out = []; roots(document, []).forEach(function (r) { r.querySelectorAll(sel).forEach(function (e) { out.push(e); }); }); return out; }
  function one(sel) { return all(sel)[0] || null; }
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }

  var root = null;

  function money(c) {
    var v = c / 100, s = (c % 100 === 0) ? String(v) : v.toFixed(2).replace('.', ',');
    var cc0 = (DATA && DATA.currency) || 'EUR';
    return s + ' ' + (SYM[cc0] || cc0);
  }

  function slotCount(pack) { return pack === 1 ? 1 : pack; }

  function idsFor(pack) {
    if (pack === 1) return [cur.id];
    return state.slots[pack].map(function (k) { return k; });
  }
  function mergeItems(ids) {
    var m = {}, order = [];
    ids.forEach(function (id) { if (!m[id]) { m[id] = 0; order.push(id); } m[id]++; });
    return order.map(function (id) { return { id: id, qty: m[id] }; });
  }
  function totals(ids, pack) {
    var sum = 0, cmp = 0;
    ids.forEach(function (id) { var s = byId[id]; sum += s.p; cmp += Math.max(s.c || 0, s.p); });
    var disc = (DATA.packDiscounts && DATA.packDiscounts[String(pack)]) || 0;
    /* Offre découverte Halloween : 2 achetés, le 3e offert (le moins cher) jusqu'à MD_OFFER.end ; ensuite retour au Pack Trio. */
    if (pack === 3 && ids.length === 3 && window.MD_OFFER && Date.now() < Date.parse(window.MD_OFFER.end)) {
      var mn = Math.min.apply(null, ids.map(function (id) { return byId[id].p; }));
      disc = mn;
    } /* remises automatiques Shopify (-12 € dès 2, -29 € dès 3) */
    var total = sum - disc + (pack === 1 ? (DATA.shipCents || 0) : 0);
    return { total: total, compare: cmp, save: pack === 1 ? 0 : cmp - total };
  }
  var NAMES = { 1: '1 pot', 2: 'Pack Découverte', 3: 'Pack Trio' };
  function labelFor(pack, ids) {
    var names = ids.map(function (id) { return byId[id].t; });
    if (pack === 1) return '1 pot · ' + names[0];
    var same = names.every(function (n) { return n === names[0]; });
    return NAMES[pack] + ' · ' + (same ? pack + ' × ' + names[0] : names.join(' + '));
  }
  function noteFor(pack) { return pack === 1 ? 'Livraison 5 €' : 'Livraison offerte'; }

  function perPot(pack, ids) { return pack === 1 ? byId[ids[0]].p : Math.round(totals(ids, pack).total / pack); }
  function selectionFor(pack, ids) {
    var t = totals(ids, pack);
    return { pack: pack, items: mergeItems(ids), total: t.total, perPot: perPot(pack, ids), label: labelFor(pack, ids), note: noteFor(pack) };
  }
  function getSelection() {
    if (!ready) return { pack: state.pack, items: [], total: 0, perPot: 0, label: '', note: '' };
    return selectionFor(state.pack, idsFor(state.pack));
  }
  function emit() {
    try { document.dispatchEvent(new CustomEvent('md:selection-change', { detail: getSelection() })); } catch (e) {}
  }

  /* ---------- rendu ---------- */
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var CHEV = '<svg class="md-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9l6 6l6-6"/></svg>';
  function img(s) { return s.i ? '<img src="' + esc(s.i) + '" alt="" width="40" height="40" loading="lazy" decoding="async">' : '<img alt="" width="40" height="40" style="visibility:hidden">'; }

  function buildSlots(pack) {
    var box = $('[data-md-slots="' + pack + '"]');
    if (!box) return;
    var h = '';
    for (var i = 0; i < pack; i++) {
      h += '<div class="md-slot" data-slot="' + i + '"><span class="md-n">' + (i + 1) + '</span><div class="md-sel">' +
        '<button type="button" class="md-cur" aria-haspopup="listbox" aria-expanded="false" aria-label="Senteur ' + (i + 1) + '"><span data-slot-img></span><span class="md-cn"><strong data-slot-name></strong><em data-slot-ev></em></span>' + CHEV + '</button>' +
        '<ul class="md-list" role="listbox" hidden>';
      S.forEach(function (s) {
        h += '<li role="presentation"><button type="button" class="md-opt" role="option" data-id="' + s.id + '" aria-selected="false"' + (s.a ? '' : ' disabled') + '>' + img(s) + '<span>' + esc(s.t) + '</span></button></li>';
      });
      h += '</ul></div></div>';
    }
    box.innerHTML = h;
  }
  function closeLists(except) {
    root.querySelectorAll('.md-slot').forEach(function (sl) {
      if (sl === except) return;
      var l = sl.querySelector('.md-list'), c = sl.querySelector('.md-cur');
      if (l && !l.hidden) { l.hidden = true; c.setAttribute('aria-expanded', 'false'); }
    });
  }
  function toggleList(sl) {
    var l = sl.querySelector('.md-list'), c = sl.querySelector('.md-cur'), open = l.hidden;
    closeLists(open ? sl : null);
    l.hidden = !open; c.setAttribute('aria-expanded', String(open));
    if (open) { var a = l.querySelector('[aria-selected="true"]'); if (a) l.scrollTop = Math.max(0, a.offsetTop - 60); }
  }

  function setText(sel, txt) { var e = $(sel); if (e) e.textContent = txt; }

  function render() {
    root.setAttribute('data-pack', String(state.pack));
    root.querySelectorAll('.md-pack').forEach(function (c) {
      var n = parseInt(c.getAttribute('data-pack'), 10);
      c.setAttribute('data-selected', n === state.pack ? 'true' : 'false');
      var r = c.querySelector('input.md-radio'); if (r) r.checked = (n === state.pack);
    });
    [2, 3].forEach(function (p) {
      var box = $('[data-md-slots="' + p + '"]'); if (!box) return;
      box.querySelectorAll('.md-slot').forEach(function (sl) {
        var i = parseInt(sl.getAttribute('data-slot'), 10), id = state.slots[p][i], s = byId[id];
        sl.querySelector('[data-slot-img]').innerHTML = img(s);
        sl.querySelector('[data-slot-name]').textContent = s.t;
        sl.querySelector('[data-slot-ev]').textContent = s.e ? 'Évoque ' + s.e : '';
        sl.querySelectorAll('.md-opt').forEach(function (b) { b.setAttribute('aria-selected', String(b.getAttribute('data-id') === String(id))); });
      });
    });
    [1, 2, 3].forEach(function (p) {
      var ids = idsFor(p), t = totals(ids, p);
      setText('[data-md="total-' + p + '"]', money(t.total));
      setText('[data-md="per-' + p + '"]', money(perPot(p, ids)) + ' le pot');
      if (p > 1) {
        var old = $('[data-md="old-' + p + '"]'), sv = $('[data-md="save-' + p + '"]');
        if (old) { old.textContent = money(t.compare); old.hidden = !(t.save > 0); }
        if (sv) { sv.textContent = 'Économisez ' + money(t.save); sv.hidden = !(t.save > 0); }
      }
    });
    var err = $('[data-md="err"]'); if (err) err.hidden = true;
  }

  function select(pack) {
    if (state.pack === pack) return;
    state.pack = pack; closeLists(null); render(); emit();
  }
  function pick(pack, slot, id) {
    state.slots[pack][slot] = id; closeLists(null); render(); emit();
  }

  /* ---------- achat direct ---------- */
  function setBusy(on) {
    busy = on;
    all('[data-md-go]').forEach(function (b) {
      b.setAttribute('aria-busy', on ? 'true' : 'false');
      var l = b.querySelector('[data-md="cta-label"]');
      if (l) {
        if (!l.getAttribute('data-idle')) l.setAttribute('data-idle', l.textContent);
        l.textContent = on ? 'Redirection vers le paiement…' : l.getAttribute('data-idle');
      }
    });
    try { document.dispatchEvent(new CustomEvent('md:checkout-state', { detail: { busy: on } })); } catch (e) {}
  }
  function showErr(fixed) {
    all('[data-md="err"], [data-md="err-fixed"]').forEach(function (e) { e.hidden = false; });
  }

  function checkout(opts) {
    if (busy && busyP) return busyP;
    if (!ready) return Promise.resolve(false);
    var sel = (opts && opts.ids) ? selectionFor(opts.pack || 3, opts.ids) : getSelection();
    if (!sel.items.length) return Promise.resolve(false);
    setBusy(true); /* etat "en cours" immediat */
    var url = '/cart/' + sel.items.map(function (i) { return i.id + ':' + i.qty; }).join(','); /* pas de code : remises automatiques */
    /* attributs panier _fbp / _fbc / _md_eid (Conversions API) portes par le permalien : aucun appel reseau en plus */
    try { if (window.mdAttrsQS) url += window.mdAttrsQS(); } catch (e) {}
    clearTimeout(busyTimer);
    busyTimer = setTimeout(function () { if (busy) { setBusy(false); showErr(); } }, 15000);
    busyP = Promise.resolve(window.mdCartIdle ? window.mdCartIdle() : null).catch(function () {}).then(function () { return fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: '{}' }); })
      .then(function (r) { if (!r.ok) throw new Error('clear ' + r.status); })
      .then(function () { window.location.assign(url); return true; })
      .catch(function () { clearTimeout(busyTimer); setBusy(false); showErr(); return false; })
      .then(function (ok) { if (!ok) busyP = null; return ok; });
    return busyP;
  }

  /* ---------- init ---------- */
  function bind() {
    root.addEventListener('change', function (e) {
      var t = e.target; if (t && t.matches && t.matches('input.md-radio')) select(parseInt(t.value, 10));
    });
    root.addEventListener('click', function (e) {
      var t = e.target; if (!t || !t.closest) return;
      var opt = t.closest('.md-opt'), cur2 = t.closest('.md-cur');
      var slot = t.closest('.md-slot'), card = t.closest('.md-pack');
      if (opt) {
        if (opt.disabled || !slot || !card) return;
        pick(parseInt(card.getAttribute('data-pack'), 10), parseInt(slot.getAttribute('data-slot'), 10), parseInt(opt.getAttribute('data-id'), 10));
      } else if (cur2 && slot) {
        toggleList(slot);
      } else closeLists(null);
    });
    document.addEventListener('click', function (e) {
      var path = e.composedPath ? e.composedPath() : [];
      if (path.indexOf(root) < 0) closeLists(null);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLists(null); });
    all('[data-md-go]').forEach(function (b) {
      if (b.__mdBound) return; b.__mdBound = true;
      b.addEventListener('click', function () {
        var fx = b.getAttribute('data-md-fixed');
        if (fx) {
          var ids = fx.split(',').map(function (h) { return byH[h] && byH[h].id; }).filter(Boolean);
          if (ids.length !== 3) { showErr(); return; }
          checkout({ pack: 3, ids: ids });
        } else checkout();
      });
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted && busy) { clearTimeout(busyTimer); setBusy(false); } });
  }

  function init() {
    root = one('[data-md-buy]');
    var node = document.getElementById('md-buy-data') || one('#md-buy-data');
    if (!root || !node) return false;
    try { DATA = JSON.parse(node.textContent); } catch (e) { return false; }
    S = (DATA.scents || []).filter(function (s) { return s && s.id; });
    if (!S.length) return false;
    S.forEach(function (s) { byId[s.id] = s; byH[s.h] = s; });
    cur = byH[DATA.current] || S[0];
    /* Par defaut : le produit courant, puis les best-sellers (Ventura, Visionaire), puis la suite de la collection. */
    var pool = [];
    function add(x) { if (x && x.a && pool.indexOf(x) < 0) pool.push(x); }
    add(cur);
    BEST.forEach(function (h) { add(byH[h]); });
    S.forEach(add);
    if (!pool.length) pool.push(cur);
    function at(i) { return (pool[i] || pool[pool.length - 1]).id; }
    state.slots[2] = [at(0), at(1)];
    state.slots[3] = [at(0), at(1), at(2)];
    buildSlots(2); buildSlots(3);
    ready = true;
    bind(); render(); emit();
    return true;
  }

  window.mdBuy = { getSelection: getSelection, checkout: checkout };

  function start() { if (init()) return; var n = 0; (function retry() { if (ready || n++ > 20) return; setTimeout(function () { if (!init()) retry(); }, 150); })(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
